import {Inject, Injectable} from "@angular/core";
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpXsrfTokenExtractor} from "@angular/common/http";
import {Observable} from "rxjs";
import {CookieService} from "ngx-cookie-service";
import {OKTA_AUTH} from "@okta/okta-angular";
import OktaAuth from "@okta/okta-auth-js";


@Injectable()
export class HttpXsrfInterceptor implements HttpInterceptor {

	cookieValue: string = "";

	constructor(@Inject(OKTA_AUTH) public oktaAuth: OktaAuth,
							private tokenExtractor: HttpXsrfTokenExtractor,
							private cookieService: CookieService) {
	}

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

		let requestMethod: string = req.method;
		requestMethod = requestMethod.toLowerCase();
		this.cookieValue = this.cookieService.get("okta-oauth-state");
		if (requestMethod && (requestMethod === 'post' || requestMethod === 'delete' || requestMethod === 'put')) {
			const headerName = 'X-XSRF-TOKEN';
			this.cookieService.set("XSRF-TOKEN", this.cookieValue);
			let token = this.tokenExtractor.getToken() as string;
			if (token !== null) {
				req = req.clone({headers: req.headers.set(headerName, token)});
			}
		}
		const AUTH_TOKEN = this.oktaAuth.getAccessToken();
		req = req.clone({
			setHeaders: {
				'Authorization': `Bearer ${AUTH_TOKEN}`
			}
		});
		// req = req.clone({headers: req.headers.set("Access-Control-Allow-Origin", window.location.origin)});
		return next.handle(req);
	}
}
